import {gql} from 'apollo-boost';

export const GET_ZONEGROUPS = gql`
  query getZoneGroups{
    getZoneGroups {
      id
      nameLocal
      nameEng
    }
  }
`;
